<template>
    <card :cardName="'gestisci'" :link="$routes.GESTISCI" :style="style" :size="config.size" :color="config.color">
        <template v-slot:icon>
            <img src="@/assets/images/gestisci_prenoatzione.svg" style="width: 300px" class="my-3 p-2" alt="icona" />
        </template>

        <template v-slot:title>
            <h5>
                {{ $t("gestisci.title") }}
            </h5>
        </template>
        <template v-slot:description>
            <div class="card-text text-sans-serif">
                {{ $t("gestisci.description") }}
            </div>
        </template>
</card>
</template>

<script>
export default {
    props: {
        config: {
            required: true,
            type: Object
        }
    },
    computed: {
        style() {
            return {
                gridArea: this.config.position,
                order: this.config.order,
            }
        }
    }
}
</script>

<style></style>